import React, { useState } from "react"
import "./App.css"
import SortingVisualizer from "./containers/SortingVisualizer"
import Header from "./components/Header"
import Footer from "./components/Footer"
import { ThemeProvider } from "styled-components"
import { lightTheme, darkTheme } from "./theme"
import { GlobalStyles } from "./global"

function App(): JSX.Element {
    const [theme, setTheme] = useState("dark")
    const toggleTheme = () => {
        if (theme === "light") {
            setTheme("dark")
        } else {
            setTheme("light")
        }
    }

    return (
        <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
            <>
                <GlobalStyles />
                <div className="wrapper">
                    <Header theme={theme} toggleTheme={toggleTheme} />
                    <main className="container mx-auto px-4">
                        <SortingVisualizer />
                    </main>
                </div>
                <Footer theme={theme} />
            </>
        </ThemeProvider>
    )
}

export default App
